import React from 'react';
import { Helmet } from "react-helmet";

import { motion } from 'framer-motion';
import '../../styles/transport.css'; // Import Transport specific CSS
import '../../styles/Fonts.css'; // Import Font specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import bgImage from '../../assets/new/sealand.webp';
import SeaLandServices from './SeaLandServices';
import SeaLandBenefits from './SeaLandBenefits';
import SeaLandOther from './SeaLandOther';
import SeaLandFAQ from './SeaLandFAQ';

const HeroSeaLand = () => {
  // Slightly faster subtle scale-up animation variant
  const scaleUpVariants = {
    hidden: { opacity: 0, scale: 0.97 },
    visible: { opacity: 1, scale: 1 }
  };

  return (
    <>
     <Helmet>
          <title>Sea Land Services</title>
          <meta name="description" content="Partner with RCS Logistics Philippines to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta name="keywords" content="logistics, transportation, RCS Logistics, Philippines, forwarding, brokerage, sea land service, freight forwarding, international shipping, supply chain management, cargo handling, customs brokerage, project cargo, warehousing, import export, air freight, ocean freight, domestic transportation, logistics services" />
          <meta property="og:url" content="https://rcslogisticsph.com/sealand" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:title" content="RCS Logistics Philippines - Moving You Forward" />
          <meta property="twitter:description" content="Partner with the best to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta property="twitter:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
        </Helmet>
      <section
        id="hero"
        className="hero-parallax transport-hero d-flex align-items-center"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="overlay"></div>
        <div className="container content-hero">
          <div className="row">
            <div className="col-lg-8 col-md-10 col-sm-12 my-4">
              <motion.div
                className="text-start"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={scaleUpVariants}
                transition={{ delay: 0.1, duration: 0.7, ease: [0.42, 0, 0.58, 1] }} // Reduced duration for faster animation
              >
                <button disabled className="custom-button mt-4 mb-4 poppins-semibold">
                  WE HELP YOU MOVE AHEAD
                </button>
                <h1 className="poppins-bold text-light hero-title">
                  SeaLand Services
                </h1>
                <p className="poppins-regular text-light hero-desc">
                  Seamless sea-land transport solutions for efficient deliveries. From port to final destination,
                  we ensure smooth, reliable, and timely shipments.
                </p>
                <div className="d-flex gap-3 mt-4 flex-wrap">
                  <a href="/contactUs" className="custom-button2 poppins-semibold text-dark">
                    Get a Quote
                  </a>
                  <a href="#about-sealand" className="custom-button3 poppins-semibold text-light">
                    Learn More
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* Include the other sections */}
      <SeaLandServices />
      <SeaLandBenefits />
      <SeaLandFAQ />
      <SeaLandOther />
    </>
  );
};

export default HeroSeaLand;
